import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=1b7c7893&"
import script from "./AppForm.vue?vue&type=script&lang=js&"
export * from "./AppForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports